<div class="modal-header d-flex justify-content-between align-items-center" *ngIf="!isSalarySlipVisible">
  <h5 class="modal-title"></h5>
  <div class="d-flex align-items-center">
    <button class="btn btn-secondary me-3" (click)="downloadImage()">
      <i class="bx bx-download me-1 font-20 text-white"></i> Download
    </button>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')" tabindex="-1"></button>
  </div>
</div>
<div *ngIf="salarySlip" id="payslip-content">
  <div class="modal-body">
    <div class="payslip-container">
      <div class="company-header d-flex align-items-center" *ngIf="!isSalarySlipVisible">
        <img src="assets/images/firecodex-logo.png" alt="Firecodex Logo" class="company-logo me-3">
        <div class="company-info">
          <h2 class="mb-0">Firecodex, PieTechies Pvt. Ltd.</h2>
          <p class="mb-0">#198, 2nd Floor, CMH Road, Indiranagar, Bangalore - 5600</p>
        </div>
      </div>
      <h3 class="payslip-title">
        <p>Payslip for the Month {{ salaryDate ? (salaryDate | date: 'MMMM yyyy') : 'N/A' }}</p>
      </h3>
      <div class="employee-bank-details">
        <table class="details-table">
          <tr>
            <td><strong>Employee Code:</strong> {{ salarySlip?.code || 'Nill' }}</td>
            <td><strong>Employee Name:</strong> {{ salarySlip?.employeeName || 'Nill' }}</td>
          </tr>
          <tr>
            <td><strong>Employee Role:</strong> {{ salarySlip?.role || 'Nill' }}</td>
            <td><strong>Employee PAN:</strong> {{ salarySlip?.pan || 'Nill' }}</td>
          </tr>
          <tr>
            <td><strong>Employee DoB:</strong> {{ salarySlip?.dob ? (salarySlip?.dob | date:'MMM dd, yyyy') : 'Nill' }}</td>
            <td><strong>Employee DoJ:</strong> {{ salarySlip?.doj ? (salarySlip?.doj | date:'MMM dd, yyyy') : 'Nill'}}</td>
          </tr>
          <tr>
            <td><strong>Bank Name:</strong> {{ salarySlip?.bankName || 'Nill' }}</td>
            <td><strong>Bank Acc. No:</strong> {{ salarySlip?.accountNo || 'Nill' }}</td>
          </tr>
          <tr>
            <td><strong>Pay From:</strong> {{ salarySlip?.payFrom ? (salarySlip.payFrom | date) : 'Nill' }}</td>
            <td><strong>Pay To:</strong> {{ salarySlip?.payTo ? (salarySlip.payTo | date) : 'Nill' }}</td>
          </tr>
          <tr>
            <td><strong>Working Days:</strong> {{ salarySlip?.workingDays || 'Nill' }}</td>
            <td><strong>Arrears Days:</strong> {{ salarySlip?.arrearsDays || 'Nill' }}</td>
          </tr>
          <tr>
            <th>Earnings</th>
            <th>Deductions</th>
          </tr>
          <tr *ngFor="let earning of salarySlip?.earnings | keyvalue; let i = index">
            <td >
              {{ earning?.key | titlecase }}: 
              {{ earning?.value != null ? (earning.value | currency:'INR') : 'Nill' }}
            </td>
            <td *ngIf="salarySlip?.deductions | keyvalue as deductionsArray">
              <ng-container *ngIf="deductionsArray[i]?.key">
                {{ deductionsArray[i]?.key | titlecase }}: 
                {{ deductionsArray[i]?.value | currency:'INR':'symbol':'1.2-2' }}
              </ng-container>
            </td>
          </tr>          
          <tr>
            <td  style="text-align: right;"colspan="2"><strong>Net Salary: ₹ {{ salarySlip?.netSalary || 'Nill' }}</strong></td>
          </tr>
          <tr>
            <td class="net" style="text-align: right;"colspan="2"><em>Net In Words: {{ salarySlip?.netSalary ? (salarySlip.netSalary | amountToWords) : 'Nill'
               }} Only</em></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>